// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase, TelemetryType } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "../../Social.telemetry";

export interface ProfileCommentItemTelemetryObjects {
    commentItem: TelemetryObjectBase;
    replyLink: TelemetryObjectBase;
    reactionCountsBtn: TelemetryObjectBase;
    reactionBreakdown: TelemetryObjectBase;
}

export const profileCommentItemTelemetryContracts = {
    /** Profile Comments > Scenario 0a */
    commentItem: {
        name: "Comments",
        content: {
            type: TelemetryContentType.Comment
        }
    },
    /** Scenario 2 click on reply/replies link */
    replyLink: {
        name: "Comment",
        behavior: TelemetryBehaviorType.Navigate,
        type: TelemetryType.ActionButton,
        content: {
            headline: "Reply",
            type: TelemetryContentType.Comment
        }
    },
    /** Scenario 3 click on reactoinCounts to open Reactionbreakdown */
    reactionCountsBtn: {
        name: "CommentReactions",
        behavior: TelemetryBehaviorType.Open,
        content: {
            headline: "Reactions",
            type: TelemetryContentType.Comment
        }
    },
    reactionBreakdown: {
        content: {
            type: TelemetryContentType.Comment
        }
    }
};

export const profileCommentItemTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    reactionCountsClicked: genericTelemetryClickDispatcher
};